import { Trans, useTranslation } from "react-i18next";
import React from "react";
import {
  Popup,
  PopupActions,
  PopupContent,
  PopupHeading,
} from "../../components/Common/Popup";
import { useAuth } from "../providers/AuthProvider";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { getYUPValidators } from "../../components/yupvalidators";
import LoadingButton from "../../components/LoadingButton";
import InputMobileNumber from "../Desktop/Pages/SubjectRegistration/Components/InputMobileNumber";
import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  content: {
    textAlign: "center",
  },
  paragraph: {
    marginBottom: theme.spacing(2),
  },
}));

const UpdateMobilePhoneDialog = (props) => {
  const { t } = useTranslation();
  const { user, patchUser, isPatching, logout } = useAuth();
  const classes = useStyles();
  return (
    <Popup onClose={props.onClose}>
      <PopupHeading>{t("Your contact details")}</PopupHeading>
      <Formik
        initialValues={{
          mobilePhone: user?.mobilePhone ?? "",
        }}
        validateOnMount={true}
        validationSchema={schema(t)}
        onSubmit={(values) => {
          patchUser({
            mobilePhone: values.mobilePhone,
          });
        }}
      >
        {({ submitForm, isValid, isSubmitting }) => {
          return (
            <Form>
              <PopupContent className={classes.content}>
                <Container maxWidth="xs">
                  <Box mb={2}>
                    <Field
                      label={t("Mobile phone")}
                      name="mobilePhone"
                      component={InputMobileNumber}
                    />
                  </Box>
                  <p className={classes.paragraph}>
                    <Trans>
                      Some contact details is missing from your user account.
                      Please fill out the form above and click save.
                    </Trans>
                  </p>
                </Container>
              </PopupContent>

              <PopupActions>
                <LoadingButton
                  isLoading={isPatching}
                  fullWidth
                  disabled={!isValid}
                >
                  {t("Save")}
                </LoadingButton>
              </PopupActions>
            </Form>
          );
        }}
      </Formik>
    </Popup>
  );
};

const schema = (t) => () => {
  const validators = getYUPValidators(t);
  return Yup.object().shape({
    mobilePhone: validators.MOBILE_PHONE_WITH_SERVER_VALIDATION.required(
      t("This is required!"),
    ),
  });
};

export default UpdateMobilePhoneDialog;
